export default __webpack_public_path__ + "static/media/free-at-home.57688cf3.webp";